module.exports = __webpack_public_path__ + "img/ar.343c555d.jpg";